<template>
  <div class="left-nav">
    <ul>
      <li
        class="nav-item"
        :class="nownav.name == item.name ? 'active-item' : ''"
        v-for="item in navarr"
        v-show="item.show"
        @click="changenav(item)"
      >
        <span class="blue-blank"> </span>
        <img :src="item.icon" alt="" />
        {{ item.name }}
      </li>
    </ul>
  </div>
</template>

<script>
import Bus from "utils/bus.js";
import Axios from "@/utils/Axios";
import Vue from "vue";

export default {
  name: "left-nav",
  props: ["navarr"],
  data() {
    return {
      nownav: "",
      menusList:"",
    };
  },
  methods: {
    changenav(data) {
      //切换侧边栏
      this.nownav = data;
      // localStorage.setItem("nownav", data);
      let url = "";
      switch (data.name) {
        case "用电告警":
          url = "/electricWarn";
          break;
        case "环境告警":
          url = "/environmentWarn";
          break;
        case "隐患预警":
          url = "/hiddenWarn";
          break;
        case "监测管理":
          url = "/stationList";
          break;
        case "评估报告":
          url = "/reportList";
          break;
        case "数据详情":
          url = "/datalist";
          break;
        case "设备管理":
          url = "/deviceManger";
          break;
        case "设备运维":
          url = "/deviceOps";
          break;
        case "用户管理":
          url = "/userManage";
          break;
        case "角色管理":
          url = "/roleManage";
          break;
        case "组织管理":
          url = "/orgManage";
          break;
        case "应用管理":
          url = "/AppManage";
          break;
        case "隐患配置":
          url = "/hiddenManage";
          break;
        case "推送配置":
          url = "/sendManger";
          break;
        case "短信配置":
          url = "/noteManage";
          break;
        case "标签管理":
          url = "/tagManage";
          break;
        case "日志管理":
          url = "/logManage";
          break;
        case "合作方管理":
          url = "/partManage";
          break;
        case "隐患管理":
          url = "/riskManage";
          break;
        case "能源监测":
          url = "/powerWatch";
          break;
        case "租户管理":
          url = "/rentManage";
          break;
        case "算法打标":
          url = "/godGetPage";
          break;
        case "初始标签":
          url = "/godReturnPage";
          break;
        default:
          url = "/newlogin";
      }
      this.$router.push(url);
      this.$emit("isshow", url);
    },

  },
  mounted() {
    let that=this
    this.menusList=Vue.prototype.menusList
    for(let i=0;i<this.navarr.length;i++){
      switch (this.navarr[i].name) {
        case "用电告警":
          this.navarr[i].show=this.menusList.indexOf('ALARM_EVENT')!='-1'?true:false
          break;
        case "环境告警":
          this.navarr[i].show=this.menusList.indexOf('ALARM_PERIPHERAL')!='-1'?true:false
          break;
        case "隐患预警":
          this.navarr[i].show=this.menusList.indexOf('ALARM_RISK')!='-1'?true:false
          break;
        case "监测管理":
          this.navarr[i].show=this.menusList.indexOf('MONITOR_MANAGE')!='-1'?true:false
          break;
        case "评估报告":
          this.navarr[i].show=this.menusList.indexOf('SAFE_REPORT')!='-1'?true:false
          break;
        case "数据详情":
          this.navarr[i].show=this.menusList.indexOf('MONITOR_DATA_DETAIL')!='-1'?true:false
          break;
        case "设备管理":
          this.navarr[i].show=this.menusList.indexOf('DEVICE_MANAGE')!='-1'?true:false
          break;
        case "设备运维":
          this.navarr[i].show=this.menusList.indexOf('DEVICE_OPERATION')!='-1'?true:false
          break;
        case "用户管理":
          this.navarr[i].show=this.menusList.indexOf('USER_MANAGE')!='-1'?true:false
          break;
        case "角色管理":
          this.navarr[i].show=this.menusList.indexOf('ROLE_MANAGE')!='-1'?true:false
          break;
        case "应用管理":
          this.navarr[i].show=this.menusList.indexOf('APP_MANAGE')!='-1'?true:false
          break;
        case "组织管理":
          this.navarr[i].show=this.menusList.indexOf('DEPT_MANAGE')!='-1'?true:false
          break;
        case "隐患配置":
          this.navarr[i].show=this.menusList.indexOf('RISK_CONFIG')!='-1'?true:false
          break;
        case "短信配置":
          this.navarr[i].show=this.menusList.indexOf('SMS_PUSH_CONFIG')!='-1'?true:false
          break;
        case "标签管理":
          this.navarr[i].show=this.menusList.indexOf('LABEL_MANAGE')!='-1'?true:false
          break;
        case "日志管理":
          this.navarr[i].show=this.menusList.indexOf('LOG_MANAGE')!='-1'?true:false
          break;
        case "合作方管理":
          this.navarr[i].show=this.menusList.indexOf('ACCOUNT_MANAGE')!='-1'?true:false
          break;
        case "隐患管理":
          this.navarr[i].show=this.menusList.indexOf('ALERT_MANAGE')!='-1'?true:false
          break;
        case "能源监测":
          this.navarr[i].show=this.menusList.indexOf('ENERGY_MONITOR')!='-1'?true:false
          break;
        case "租户管理":
          this.navarr[i].show=this.menusList.indexOf('ALERT_MANAGE')!='-1'?true:false
          break;
        case "推送配置":
          this.navarr[i].show=this.menusList.indexOf('WARN_PUSH_CONFIG')!='-1'?true:false
          break;
        case "算法打标":
          this.navarr[i].show=true
          break;
        case "初始标签":
          this.navarr[i].show=true
          break;
        default:
      }
    }
    if(that.$route.path=='/hiddenWarn'){
      this.changenav({
        icon:"",
        name: "隐患预警",
        show: true,
      })
    }else{
      for(let i=0;i<this.navarr.length;i++){
        if(this.navarr[i].show){
          this.nownav = this.navarr[i];
          this.changenav(this.nownav)
          break;
        }
      }
    }



  },
  destroyed() {

  },
  computed: {},
  watch: {},
  components: {},
};
</script>

<style lang="less" rel="stylesheet/less" scoped>
.left-nav {
  width: 240px;
  height: 100%;
  display: inline-block;
  vertical-align: top;
  background-color: #fff;
  background-image: url("../assets/leftnav/bg.png");
  background-size: 100% 100%;
  ul {
    width: 100%;

    .nav-item {
      height: 65px;
      line-height: 65px;
      text-align: center;
      font-size: 16px;
      color: #252b3c;
      font-weight: 600;
      position: relative;
      cursor: pointer;
      font-family: "opposans";
      letter-spacing: 2px;
      img {
        position: relative;
        top: 24px;
        margin-right: 4px;
      }
      .blue-blank {
        position: absolute;
        top: 0;
        left: 0;
        width: 10px;
        height: 65px;
        display: inline-block;
      }
    }
    .active-item {
      background-color: rgba(42, 98, 255, 0.15);
      .blue-blank {
        position: absolute;
        top: 0;
        left: 0;
        width: 10px;
        height: 65px;
        background-color: #2a62ff;
        display: inline-block;
      }
    }
  }
}
</style>
